angular.module('jv.candidate.details.processform.fac', [])
    .factory('jvCandidateDetailsProcessFormFAC', [function(){
        return function(candidateForm){
            angular.forEach(candidateForm.forms, function(form) {
                var obj = form.json;
                if (obj.section && !angular.isArray(obj.section)) {
                    var temp = angular.copy(obj.section);
                    obj.section = [];
                    obj.section.push(temp);
                }
                angular.forEach(obj.section, function(section) {
                    if (section.element && !angular.isArray(section.element)) {
                        var temp = angular.copy(section.element);
                        section.element = [];
                        section.element.push(temp);
                    }
                    var elements = section.element;
                    angular.forEach(elements, function(elem) {
                        if (elem.kind === '12') {
                            if (elem.value) {
                                elem.newValue = elem.value.split('\n');
                            } else {
                                elem.newValue = [];
                            }
                            elem.newRow = [];

                            //1st ROW
                            elem.header = [];
                            if (elem.columns) {
                                angular.forEach(elem.columns.item, function(val) {
                                    elem.header.push(val.name);
                                });
                            }

                            var k = 0;
                            if (elem.rows && elem.rows.item) {
                                for (var i = 0; i < elem.rows.item.length; i++) {
                                    elem.newRow[i] = [];
                                    for (var j = 0; j < elem.header.length - 1; j++, k++) {
                                        if (j === 0) {
                                            elem.newRow[i].push(elem.rows.item[i].name);
                                        }
                                        elem.newRow[i].push(elem.newValue[k] || '-');
                                    }
                                }
                            }
                        } else if (elem.kind === '102' || elem.kind === '13') {
                            if (elem.value) {
                                elem.newValue = elem.value.split('\n');
                            }
                        } else if (elem.kind === '9') {
                            if (elem.value) {
                                elem.newValue = elem.value.split('\n');
                                for (var l = 0; l < elem.choices.item.length; l++) {
                                    for (var m = 0; m < elem.newValue.length; m++) {
                                        if (elem.newValue[m].trim() === elem.choices.item[m].name.trim()) {
                                            elem.choices.item[l].selected = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        } else if (elem.kind === '7') {
                            //  For Drop Down
                            if (elem.value) {
                                // Removing Only choices which are not selected
                                elem.newValue = elem.value.split('\n');
                                for (var x = 0; x < elem.choices.item.length; x++) {
                                    if (elem.newValue.indexOf(elem.choices.item[x].name) < 0) {
                                        elem.choices.item[x].remove = true;
                                    }
                                }
                            }
                            else{
                                //Removing all the choices as nothing is selected
                                for (var y = 0; y < elem.choices.item.length; y++) {
                                    elem.choices.item[y].remove = true;
                                }
                            }
                            //  Remove unselected items
                            for (var z = 0; z < elem.choices.item.length; z++) {
                                if (elem.choices.item[z] && elem.choices.item[z].remove) {
                                    elem.choices.item.splice(z,1);
                                    z--;
                                }
                            }

                        } else {
                            //JUST IN CASE OF A NEW KIND NEEDS CHECK: SMS
                        }
                    });
                });
            });
            return candidateForm;
        };
    }]);